import { useState, useEffect } from "react"
import { EscolaridadeKeys, escolaridadeKeyToLabel, IEscolaridade } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
// Icon
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteEscolaridade = () => {
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Use State
    const [selectedEscolaridade, setSelectedEscolaridade] = useState<IEscolaridade[]>([])
    // Hook
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    useEffect(() => {
        const escolaridadesSelecionadas = createRecorteExtracaoForm.fields.Filtros?.escolaridade || [];

        if (escolaridadesSelecionadas.length > 0) {
            setSelectedEscolaridade(escolaridadesSelecionadas);
        } else {
            setSelectedEscolaridade([]);
        }
    }, [createRecorteExtracaoForm.fields.Filtros?.escolaridade]);

    // Filtra as opções para remover os itens já selecionados
    const filteredEscolaridades = EscolaridadeKeys.filter((escolaridade: IEscolaridade) =>
        !selectedEscolaridade.some((selected: IEscolaridade) => selected === escolaridade)
    );

    const handleEscolaridadeSelectionChange = (value: IEscolaridade[]) => {
        setSelectedEscolaridade(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'escolaridade',
                value: value,
                formType: 'create'
            });
        } else {
            removeFilterFromForm({
                filtro: 'escolaridade',
                formType: 'create'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredEscolaridades}
                    getOptionLabel={(option) => escolaridadeKeyToLabel(option).toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    value={selectedEscolaridade}
                    onChange={(event, value) => {
                        handleEscolaridadeSelectionChange(value);
                    }}
                    noOptionsText='Nenhuma escolaridade encontrada'
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de tipos de escolaridade"
                        />
                    )}
                />
            </Grid>
        </>
    )
}